"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.APPEARANCES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Ellipsis = _interopRequireWildcard(require("../common/Ellipsis"));

var _HeadingSt = require("./Heading.st.css");

var _EllipsisCommon = require("../common/PropTypes/EllipsisCommon");

var _excluded = ["light", "appearance", "children", "dataHook"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var APPEARANCES = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6'
};
exports.APPEARANCES = APPEARANCES;

var Heading = function Heading(props) {
  var _extractEllipsisProps = (0, _Ellipsis.extractEllipsisProps)(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  var light = componentProps.light,
      appearance = componentProps.appearance,
      children = componentProps.children,
      dataHook = componentProps.dataHook,
      headingProps = (0, _objectWithoutProperties2["default"])(componentProps, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Ellipsis["default"], (0, _extends2["default"])({}, ellipsisProps, {
    wrapperClassName: (0, _HeadingSt.st)(_HeadingSt.classes.root, {
      appearance: appearance
    }),
    render: function render(_ref) {
      var ref = _ref.ref,
          ellipsisClasses = _ref.ellipsisClasses;
      return /*#__PURE__*/_react["default"].createElement(appearance.toLowerCase(), _objectSpread(_objectSpread({}, headingProps), {}, {
        ref: ref,
        'data-hook': dataHook,
        className: (0, _HeadingSt.st)(_HeadingSt.classes.root, {
          light: light,
          appearance: appearance
        }, ellipsisClasses(props.className)),
        'data-appearance': appearance,
        'data-light': light
      }), children);
    }
  }));
};

Heading.displayName = 'Heading';
Heading.propTypes = _objectSpread({
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: _propTypes["default"].string,

  /** Renders any kind of content within a heading. Usually it’s a text string. */
  children: _propTypes["default"].any,

  /** Invert heading style so it can be used on a dark or image background. */
  light: _propTypes["default"].bool,

  /** Set the size of a heading. */
  appearance: _propTypes["default"].oneOf(Object.keys(APPEARANCES))
}, _EllipsisCommon.EllipsisCommonProps);
Heading.defaultProps = _objectSpread({
  appearance: APPEARANCES.H1,
  light: false
}, _Ellipsis["default"].defaultProps);
var _default = Heading;
exports["default"] = _default;